module.exports = __webpack_public_path__ + "img/img (54).6d9f7772.jpg";